import * as React from 'react';
import { format, parseISO, isValid } from 'date-fns';
import { Calendar as CalendarIcon } from 'lucide-react';
import { Calendar } from './calendar';
import { Popover, PopoverContent, PopoverTrigger } from './popover';
import { cn } from './utils';

function parseValue(value) {
  if (!value) return undefined;
  const date = typeof value === 'string' ? parseISO(value) : value;
  return isValid(date) ? date : undefined;
}

function DatePicker({
  value,
  onChange,
  placeholder = 'dd/mm/aaaa',
  className,
  disabled = false,
  fromYear,
  toYear,
  ...calendarProps
}) {
  const [open, setOpen] = React.useState(false);
  const selected = parseValue(value);
  const now = new Date();
  const startMonth = new Date(fromYear ?? now.getFullYear() - 100, 0);
  const endMonth = new Date(toYear ?? now.getFullYear(), 11);

  const handleSelect = (date) => {
    onChange?.(date ? format(date, 'yyyy-MM-dd') : '');
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          className={cn(
            'inline-flex h-10 w-[220px] items-center justify-between gap-2 rounded-md border border-transparent bg-[#F9FAFB] px-3 text-left text-sm text-gray-900',
            'hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-300',
            'disabled:cursor-not-allowed disabled:opacity-50',
            !selected && 'text-gray-400',
            className
          )}
        >
          <span className="truncate">
            {selected ? format(selected, 'dd/MM/yyyy') : placeholder}
          </span>
          <CalendarIcon className="size-4 shrink-0 text-gray-500" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={handleSelect}
          defaultMonth={selected || now}
          startMonth={startMonth}
          endMonth={endMonth}
          {...calendarProps}
        />
      </PopoverContent>
    </Popover>
  );
}

export { DatePicker };
